module.exports = __webpack_public_path__ + "static/media/icon-back.f595a7c6.svg";